//#region ../schema-sql-parser/dist/parser/dataType/PostgreSQL.js
var PostgreSQLTypes = [
	"BIGINT",
	"BIGSERIAL",
	"BIT VARYING",
	"BIT",
	"BOOL",
	"BOOLEAN",
	"BOX",
	"BPCHAR",
	"BYTEA",
	"CHAR",
	"CHARACTER VARYING",
	"CHARACTER",
	"CID",
	"CIDR",
	"CIRCLE",
	"DATE",
	"DATEMULTIRANGE",
	"DATERANGE",
	"DEC",
	"DECIMAL",
	"DOUBLE PRECISION",
	"FLOAT",
	"FLOAT4",
	"FLOAT8",
	"INET",
	"INT",
	"INT2",
	"INT4",
	"INT4MULTIRANGE",
	"INT4RANGE",
	"INT8",
	"INT8MULTIRANGE",
	"INT8RANGE",
	"INTEGER",
	"INTERVAL DAY TO HOUR",
	"INTERVAL DAY TO MINUTE",
	"INTERVAL DAY TO SECOND",
	"INTERVAL DAY",
	"INTERVAL HOUR TO MINUTE",
	"INTERVAL HOUR TO SECOND",
	"INTERVAL HOUR",
	"INTERVAL MINUTE TO SECOND",
	"INTERVAL MINUTE",
	"INTERVAL MONTH",
	"INTERVAL SECOND",
	"INTERVAL YEAR TO MONTH",
	"INTERVAL YEAR",
	"INTERVAL",
	"JSON",
	"JSONB",
	"JSONPATH",
	"LINE",
	"LSEG",
	"MACADDR",
	"MACADDR8",
	"MONEY",
	"NAME",
	"NUMERIC",
	"NUMMULTIRANGE",
	"NUMRANGE",
	"OID",
	"PATH",
	"PG_LSN",
	"PG_SNAPSHOT",
	"POINT",
	"POLYGON",
	"REAL",
	"REGCLASS",
	"REGCOLLATION",
	"REGCONFIG",
	"REGDICTIONARY",
	"REGNAMESPACE",
	"REGOPER",
	"REGOPERATOR",
	"REGPROC",
	"REGPROCEDURE",
	"REGROLE",
	"REGTYPE",
	"SERIAL",
	"SERIAL2",
	"SERIAL4",
	"SERIAL8",
	"SMALLINT",
	"SMALLSERIAL",
	"TEXT",
	"TID",
	"TIME WITH TIME ZONE",
	"TIME WITHOUT TIME ZONE",
	"TIME",
	"TIMESTAMP WITH TIME ZONE",
	"TIMESTAMP WITHOUT TIME ZONE",
	"TIMESTAMP",
	"TIMESTAMPTZ",
	"TIMETZ",
	"TSMULTIRANGE",
	"TSQUERY",
	"TSRANGE",
	"TSTZMULTIRANGE",
	"TSTZRANGE",
	"TSVECTOR",
	"TXID_SNAPSHOT",
	"UUID",
	"VARBIT",
	"VARCHAR",
	"XID",
	"XID8",
	"XML"
];
//#endregion
export { PostgreSQLTypes };
